import React, { useEffect, useState } from "react";
import { Image, ScrollView, Text, TouchableOpacity, View } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../utility/NavigationHelper";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import Separator from "../Separator";
import { AppImages } from "../../utility/AppImages";
import { AppScreens } from "../../screens/Utility/AppScreens";

import { toast } from "react-toastify";
import ProfileGamesSkeleton from "../skeleton-components/ProfileGamesSkeleton";

interface Game {
  gameImage?: any;
  gameTitle: string;
}

interface UserProfileData {
  selectedGamesDetails?: Game[];
}

interface UserData {
  username: string;
}

interface MyGamesProps {
  userProfileData?: UserProfileData;
  isEditable?: boolean;
  userData?: UserData;
  isLoading?: boolean;
}

const MyGames: React.FC<MyGamesProps> = ({
  userProfileData,
  isEditable = true,
  isLoading = false,
  userData,
}) => {
  const deviceSize = useDeviceSize();
  const styles = useStyles();
  const navigation = useNavigation();

  if (isLoading) {
    return <ProfileGamesSkeleton />;
  }

  return (
    <View
      style={{
        flex: 1,
        width:
          deviceSize === DEVICE_SIZES.SM ||
          deviceSize === DEVICE_SIZES.XS ||
          deviceSize === DEVICE_SIZES.MD ||
          deviceSize === DEVICE_SIZES.LG
            ? "100%"
            : 391,
      }}
    >
      <LinearGradient
        colors={["rgba(31, 41, 55, 0.50)", "rgba(17, 24, 39, 0.50)"]}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
        style={{
          flex: 1,
          padding: 18,
          borderColor: "#374151",
          borderWidth: 0.8,
          borderRadius: 8,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Text style={AppFontStyle.BOLD_ANYBODY_24}>My games</Text>
          {isEditable && (
            <TouchableOpacity
              onPress={async () => {
                navigateToScreen(navigation, AppScreens.ChooseGameLikeScreen, {
                    username: userData?.username,
                    flag: 1,
                  });
              }}
            >
              <Image
                source={AppImages.icPlusWithRound}
                style={{ height: 32, width: 32, resizeMode: "contain" }}
              />
            </TouchableOpacity>
          )}
        </View>

        <Separator
          color="#374151"
          height={1}
          marginTop={12}
          marginBottom={12}
          marginHorizontal={0}
        />
        <ScrollView
          style={{ maxHeight: 191 }}
          showsVerticalScrollIndicator={false}
        >
          {userProfileData?.selectedGamesDetails?.map((item, index) => (
            <View
              key={index}
              style={{
                flexDirection: "row",
                gap: 5,
                alignItems: "center",
                padding: 10,
              }}
            >
              <Image
                source={item?.gameImage || AppImages.icFreeFireGame}
                style={{
                  height: 48,
                  width: 48,
                  resizeMode: "contain",
                  borderRadius: 12,
                }}
              />
              <Text style={AppFontStyle.MEDIUM_ANYBODY_18}>
                {item?.gameTitle}
              </Text>
            </View>
          ))}
        </ScrollView>
      </LinearGradient>
    </View>
  );
};

export default MyGames;

const useStyles = CreateResponsiveStyle(
  {},
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {},
  }
);
